module.exports = __webpack_public_path__ + "static/media/female-judge_1f469-200d-2696-fe0f-2.436f9f19.png";